/* eslint-disable */
// VENDORED from learning_brain_poc/rhs4_explain.js (W7b / F3, POC commit 6ad5075e). Side-effect module: sets a window global.
// V5 addition (only change): the 'Last answer' row of the percentage popover, from card.last_move (tse:diag_state last.moved).
// Chat v4 right-hand side: 'how was this percentage reached' popovers for the Causes list (percentage, bar, track record)
// and the help for the In season strength select. The numbers come from each card's `explain` (brain.score_cards + rule_out.soften);
// nothing is recomputed here except the plain track-record arithmetic, so the panel can never disagree with the engine.
// window.Rhs4Explain = {pctTrigger, barHover, trackTrigger ('how?' popover + title), boostHelp, hotTitle}; deps = {h, cleanLabel, muted, pct, plural, causeInfo, card, kNow, focus, cap}.
// V5 (item 4): a popover given opts.short shows only a short form (name + one-line gist) and a Details button; Details opens the
// full content in one closeable side panel over the right panel (× or Esc closes, another Details swaps its content).
(function () {
  'use strict';

  // one place for the server's `explain` key names, so a rename on the server is a one-line change here
  const KEY = {
    prior: 'prior_log', evidence: 'evidence_log', nObs: 'n_obs', boost: 'boost', soft: 'soft_factor', score: 'score',
    shareBefore: 'share_before_adjust', adjust: 'adjust_factor', reasons: 'adjust_reasons', open: 'open_count',
    renorm: 'renorm', cases: 'cases_w_now', wrong: 'wrong_w_now', trust: 'trust',
  };
  const NO_DETAIL = 'Detail not available for this cause.';
  const HOVER_CLOSE_MS = 200, NUM_DIGITS = 2, NO_FACTOR = 1;
  const POP_GAP_PX = 6, POP_MIN_PX = 120;      // POP_GAP_PX matches the 6px gap in rhs4_explain.css
  const CLIPS = new Set(['auto', 'scroll', 'hidden', 'clip']);
  const FIXED_EDGE_PX = 8, FIXED_WIDTH_PX = 420, FIXED_MAX_SHARE = 0.7;   // at most 70% of the right panel's height, scrolling inside   // a fixed popover (cause detail) keeps this margin inside the right panel
  const BOOK_TRUST_WEIGHT = 1;   // brain.BOOK_TRUST_WEIGHT: a guide cause starts with the weight of one confirmed case
  const HOTLINE_DAYS = 30;       // brain.HOTLINE_DAYS
  const TRUST_MATCH = 0.005;     // the book bonus is not sent: the variant whose result matches the server's trust is shown
  // plain words for score_explain.REASON_* (exact server strings); an unknown reason is shown as sent
  const REASON_TEXT = {
    'suspect: a check of this cause was denied': 'One of its checks did not confirm it, so it keeps only a small part of its weight.',
    'an alternative check was denied': 'One of its alternative checks came back no, so it keeps half its weight.',
    'read from the first message, not asked yet': 'Something in the first message argues against it (not asked yet).',
    'ruled out in this chat': 'Ruled out in this chat.',
  };
  const SOFT_TEXT = 'A guide rule-out applied, but past conversations contradicted it, so it is weakened, not removed.';
  const BOOST_TEXT = 'Marking a cause In season (the flame on its row) multiplies its starting weight by the chosen factor for ' + HOTLINE_DAYS +
    ' days, so it ranks higher while the answers say little. It is an SME setting: nothing is learned from it, it expires by itself, ' +
    'and once the answers clearly point to another cause it no longer changes the outcome.';
  const SOFTMAX_NOTE = 'Technical: share = e^score ÷ the sum of e^score over the open causes (a softmax). Scores are natural logs.';

  // short form + Details side panel
  const SHORT_MAX_CHARS = 140, SHORT_TITLE_MAX_CHARS = 80;   // the gist and the title are cut at a word near this length
  const SHORT_WORD_SHARE = 0.6;      // a cut goes back to the last space only when that keeps at least 60% of the allowed length
  const ELLIPSIS = '…';
  const SHORT_WIDTH_PX = 300;        // a fixed popover in short form: the width of .v4-xp-shortpop in brain-panel-extras.css
  const SHEET_WIDTH_PX = 440;
  const SHEET_TEXT = {details: 'Details', close: 'Close details', detailsOf: label => 'Details: ' + label};

  let openPop = null, pinnedKey = null, closeTimer = null, docBound = false, popSeq = 0, refocusing = false;
  let sheet = null, sheetSync = false;   // the one Details panel (built on first use, inside the right panel); a rebuild queued for it

  const num = v => (v === null || v === undefined || !Number.isFinite(Number(v))) ? null : Number(v);
  const fmt = v => num(v) === null ? '–' : num(v).toFixed(NUM_DIGITS);
  const signed = v => num(v) === null ? '–' : (num(v) >= 0 ? '+' : '−') + Math.abs(num(v)).toFixed(NUM_DIGITS);
  const pct1 = v => num(v) === null ? '–' : Math.round(num(v) * 100) + '%';
  const PTS_DIGITS = 1;
  const points = v => (v >= 0 ? '+' : '−') + +Math.abs(v).toFixed(PTS_DIGITS) + ' pts';
  const plainPoints = v => +Math.abs(v).toFixed(PTS_DIGITS) + ' percentage point' + (+Math.abs(v).toFixed(PTS_DIGITS) === 1 ? '' : 's');
  const bold = (d, text) => d.h('b', null, text);
  const get = (e, k) => (e && KEY[k] in e) ? e[KEY[k]] : undefined;
  // one line of plain text at most max characters: whitespace collapsed, cut at a word where possible, an ellipsis when cut
  function shorten(text, max) {
    const limit = max || SHORT_MAX_CHARS, t = String(text === null || text === undefined ? '' : text).replace(/\s+/g, ' ').trim();
    if (t.length <= limit) return t;
    const cut = t.slice(0, limit - ELLIPSIS.length), space = cut.lastIndexOf(' ');
    return (space >= limit * SHORT_WORD_SHARE ? cut.slice(0, space) : cut).replace(/[\s.,;:·→-]+$/, '') + ELLIPSIS;
  }

  // ---------- popover mechanics: hover or focus opens, a click or tap pins, Esc or a click outside closes ----------
  function close(pop, refocus) {
    if (!pop || pop.panel.hidden) return;
    pop.panel.hidden = true;
    pop.btn.setAttribute('aria-expanded', 'false');
    if (openPop === pop) openPop = null;
    if (pinnedKey === pop.key) pinnedKey = null;
    if (refocus) { refocusing = true; pop.btn.focus(); refocusing = false; }   // focus goes back without reopening it
  }
  function open(pop, pin) {
    clearTimeout(closeTimer);
    if (openPop && openPop !== pop) close(openPop, false);
    // rebuilt only when it opens: a hover or a pin never rebuilds an open one (no flicker, folds and scroll stay as they are)
    // built marks a refresh popover too, so a focus then a click on an open one (a map node) does not append a second copy
    if (pop.refresh && pop.panel.hidden) { pop.panel.replaceChildren(pop.body(!!pin || pinnedKey === pop.key)); pop.built = true; }
    else if (!pop.built) { pop.panel.append(pop.body()); pop.built = true; }   // built on first open: a long cause list stays cheap
    pop.panel.hidden = false;
    placeWhenAttached(pop);
    pop.btn.setAttribute('aria-expanded', 'true');
    openPop = pop;
    if (pin) pinnedKey = pop.key;
    pop.panel.dataset.pinned = String(pinnedKey === pop.key);   // css hides 'Click to keep open' once pinned
  }
  // the part of the screen the popover can use: the viewport cut by every clipping or scrolling ancestor (the right panel)
  function visibleArea(node) {
    let top = 0, bottom = window.innerHeight;
    for (let n = node.parentElement; n; n = n.parentElement) {
      if (!CLIPS.has(window.getComputedStyle(n).overflowY)) continue;
      const r = n.getBoundingClientRect();
      top = Math.max(top, r.top); bottom = Math.min(bottom, r.bottom);
    }
    return {top, bottom};
  }
  // opens below its trigger; flips above when below is too short and above has more room; scrolls inside when neither fits
  function place(pop) {
    if (pop.fixed) { placeFixed(pop); return; }
    const p = pop.panel;
    p.classList.remove('v4-xp-up'); p.style.maxHeight = ''; p.style.overflowY = '';
    const area = visibleArea(pop.wrap), t = pop.btn.getBoundingClientRect(), h = p.offsetHeight;
    const below = area.bottom - t.bottom - POP_GAP_PX, above = t.top - area.top - POP_GAP_PX;
    if (h <= below) return;
    const up = above > below;
    if (up) p.classList.add('v4-xp-up');
    const room = up ? above : below;
    if (h > room) { p.style.maxHeight = Math.max(POP_MIN_PX, room) + 'px'; p.style.overflowY = 'auto'; }
  }
  // a fixed popover (it may sit in the scrolling map) is laid out against the right panel and the viewport, never clipped by a parent
  function placeFixed(pop) {
    const p = pop.panel, t = pop.btn.getBoundingClientRect();
    const box = (pop.wrap.closest('.v4-rhs') || document.body).getBoundingClientRect();
    const left0 = Math.max(box.left, 0) + FIXED_EDGE_PX, right0 = Math.min(box.right, window.innerWidth) - FIXED_EDGE_PX;
    const top0 = Math.max(box.top, 0) + FIXED_EDGE_PX, bottom0 = Math.min(box.bottom, window.innerHeight) - FIXED_EDGE_PX;
    const width = Math.max(Math.min(pop.short ? SHORT_WIDTH_PX : FIXED_WIDTH_PX, right0 - left0), POP_MIN_PX);
    const cap = Math.max(POP_MIN_PX, (bottom0 - top0) * FIXED_MAX_SHARE);
    p.style.width = width + 'px'; p.style.maxHeight = cap + 'px'; p.style.overflowY = 'auto';
    p.style.left = Math.max(left0, Math.min(t.left, right0 - width)) + 'px';
    const h = p.offsetHeight, below = bottom0 - t.bottom - POP_GAP_PX, above = t.top - top0 - POP_GAP_PX;
    const up = h > below && above > below, room = up ? above : below, fit = Math.max(POP_MIN_PX, Math.min(room, cap));
    if (h > room) p.style.maxHeight = fit + 'px';
    p.style.top = (up ? t.top - POP_GAP_PX - Math.min(h, fit) : t.bottom + POP_GAP_PX) + 'px';
  }
  // re-renders an open popover in place (cause detail: its data arrived); nothing happens when it is closed or another is open
  // the Details panel showing this key is re-rendered too (scroll kept)
  function refresh(key) {
    if (sheetOpen(key)) fillSheet();
    if (!openPop || openPop.key !== key || !openPop.refresh) return;
    openPop.panel.replaceChildren(openPop.body(pinnedKey === key));
    placeWhenAttached(openPop);
  }
  // a popover reopened during a re-render is not in the document yet (height 0): measure it on the next frame, once attached
  function placeWhenAttached(pop) {
    if (pop.wrap.isConnected) { place(pop); return; }
    requestAnimationFrame(() => { if (pop.wrap.isConnected && !pop.panel.hidden) place(pop); });
  }
  // New chat: no explanation of the previous chat may reopen pinned, and the Details panel closes
  function reset() { clearTimeout(closeTimer); pinnedKey = null; openPop = null; closeSheet(false); }
  // true while this key's popover or its Details panel is shown (cause detail: is the write-up still wanted after the debounce)
  const isOpen = key => sheetOpen(key) || !!(openPop && openPop.key === key && !openPop.panel.hidden);

  // ---------- Details panel: the full content of one popover, beside the list and map; × or Esc closes, focus moves in ----------
  const sheetOpen = key => !!(sheet && !sheet.el.hidden && sheet.el.isConnected && (key === undefined || sheet.key === key));
  function buildSheet(d, host) {
    const title = d.h('h3', {class: 'v4-xp-sheet-title'});
    const shut = d.h('button', {type: 'button', class: 'v4-xp-sheet-close', 'aria-label': SHEET_TEXT.close, title: SHEET_TEXT.close,
      onclick: e => { e.stopPropagation(); closeSheet(true); }}, '×');
    const body = d.h('div', {class: 'v4-xp-sheet-body'});
    const el = d.h('section', {class: 'v4-xp-sheet', role: 'dialog', 'aria-modal': 'false', tabindex: '-1', hidden: true},
      d.h('div', {class: 'v4-xp-sheet-head'}, title, shut), body);
    el.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeSheet(true); } });
    host.append(el);
    return {el, title, body, host, key: null, pop: null};
  }
  // laid out against the right panel like a fixed popover: its full height, on its right edge, never clipped by a scrolling parent
  function placeSheet() {
    if (!sheetOpen()) return;
    const box = sheet.host.getBoundingClientRect(), s = sheet.el.style;
    const left0 = Math.max(box.left, 0) + FIXED_EDGE_PX, right0 = Math.min(box.right, window.innerWidth) - FIXED_EDGE_PX;
    const top0 = Math.max(box.top, 0) + FIXED_EDGE_PX, bottom0 = Math.min(box.bottom, window.innerHeight) - FIXED_EDGE_PX;
    const width = Math.max(Math.min(SHEET_WIDTH_PX, right0 - left0), POP_MIN_PX);
    s.width = width + 'px'; s.left = Math.max(left0, right0 - width) + 'px';
    s.top = top0 + 'px'; s.height = Math.max(POP_MIN_PX, bottom0 - top0) + 'px';
  }
  function fillSheet() {
    const scroll = sheet.body.scrollTop;
    sheet.body.replaceChildren(sheet.pop.full(true));   // built as pinned: the cause detail loads its write-up at once
    sheet.body.scrollTop = scroll;
  }
  function showDetails(pop) {
    const host = pop.wrap.closest('.v4-rhs') || document.getElementById('v4-rhs');
    if (!host) return;
    if (!sheet || sheet.host !== host || !sheet.el.isConnected) { if (sheet) sheet.el.remove(); sheet = buildSheet(pop.d, host); }
    const swap = sheetOpen();
    close(pop, false);
    sheet.key = pop.key; sheet.pop = pop;
    sheet.title.textContent = pop.label;
    sheet.el.setAttribute('aria-label', pop.label);
    sheet.body.scrollTop = 0;
    sheet.body.replaceChildren(pop.full(true));
    sheet.el.hidden = false;
    placeSheet();
    if (!swap || !sheet.el.contains(document.activeElement)) sheet.el.focus();
  }
  // a trigger of the shown key that is still in the document (a re-render replaced the original)
  function sheetTrigger() {
    const own = sheet.pop && sheet.pop.btn;
    if (own && own.isConnected) return own;
    const prefix = 'v4-xp-' + sheet.key.replace(/[^\w-]/g, '_') + '-';
    return sheet.host.querySelector('[aria-controls^="' + prefix + '"]');
  }
  function closeSheet(refocus) {
    if (!sheetOpen()) return;
    const back = refocus ? sheetTrigger() : null;
    sheet.el.hidden = true;
    sheet.body.replaceChildren();
    sheet.key = null; sheet.pop = null;
    if (back) { refocusing = true; back.focus(); refocusing = false; }   // focus goes back without reopening the popover
  }
  // a re-render built a new popover for the shown key: the panel follows the new data once per render (several triggers share a key)
  function adoptSheet(pop) {
    if (!sheetOpen(pop.key)) return;
    sheet.pop = pop;
    if (sheetSync) return;
    sheetSync = true;
    Promise.resolve().then(() => { sheetSync = false; if (sheetOpen()) fillSheet(); });
  }
  // the short form of a popover: its name, a one-line gist and the Details button
  function shortView(pop, s) {
    const d = pop.d, v = s || {};
    return d.h('div', {class: 'v4-xp-short'},
      v.title ? d.h('div', {class: 'v4-xp-short-title'}, shorten(v.title, SHORT_TITLE_MAX_CHARS)) : null,
      v.gist ? d.h('p', {class: 'v4-xp-gist'}, shorten(v.gist)) : null,
      d.h('button', {type: 'button', class: 'v4-link v4-xp-details', 'aria-label': SHEET_TEXT.detailsOf(pop.label),
        onclick: e => { e.stopPropagation(); showDetails(pop); }}, SHEET_TEXT.details));
  }
  // opens the Details panel of an existing trigger (a link inside one write-up to another explanation swaps the panel's content)
  function detailsFor(trigger) {
    const wrap = trigger && (trigger.pop ? trigger : trigger.closest('.v4-xp'));
    if (wrap && wrap.pop) showDetails(wrap.pop);
  }
  const later = pop => { clearTimeout(closeTimer); closeTimer = setTimeout(() => { if (pinnedKey !== pop.key) close(pop, false); }, HOVER_CLOSE_MS); };
  function bindDoc() {
    if (docBound) return;
    docBound = true;
    document.addEventListener('click', e => { if (openPop && !openPop.wrap.contains(e.target) && !(openPop.extra || []).some(x => x.contains(e.target))) close(openPop, false); });
    // a fixed popover follows its trigger; scrolling inside the popover itself is the reader's, not a move
    const follow = e => {
      if (openPop && openPop.fixed && openPop.wrap.isConnected && !(e && e.target instanceof Node && openPop.panel.contains(e.target))) place(openPop);
      if (sheetOpen() && !(e && e.target instanceof Node && sheet.el.contains(e.target))) placeSheet();
    };
    document.addEventListener('scroll', follow, true);
    window.addEventListener('resize', follow);
  }
  // opts (cause detail): fixed = laid out against the right panel; refresh = body(pinned) is rebuilt on every open; role, cls
  // opts.trigger: an existing element (a map cause node) is the trigger instead of a new button; the returned wrap then only holds
  // the panel and is placed by the caller. That element's own click (select) still runs; it also pins.
  // opts.short(pinned) -> {title, gist}: the popover (hover or pinned) shows only that and a Details button; body(pinned) then
  // fills the Details panel instead of the popover.
  function popover(d, key, label, btnProps, btnKids, body, opts) {
    const o = opts || {};
    bindDoc();
    const id = 'v4-xp-' + key.replace(/[^\w-]/g, '_') + '-' + (++popSeq);   // the same cause can have several triggers (card, list, map)
    const btn = o.trigger || d.h('button', Object.assign({type: 'button'}, btnProps), btnKids);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    const panel = d.h('div', {class: 'v4-xp-pop' + (o.fixed ? ' v4-xp-fixed' : '') + (o.cls ? ' ' + o.cls : ''), id: id, role: o.role || 'group', 'aria-label': label, hidden: true});
    const wrap = d.h('span', {class: 'v4-xp'}, o.trigger ? null : btn, panel);
    const pop = {key, btn, panel, wrap, body, full: body, label, d, short: typeof o.short === 'function', built: false,
      extra: o.trigger ? [o.trigger] : [], fixed: !!o.fixed, refresh: !!o.refresh};
    if (pop.short) { pop.body = pinned => shortView(pop, o.short(pinned)); panel.classList.add('v4-xp-shortpop'); }
    const inside = t => t instanceof Node && (wrap.contains(t) || btn.contains(t));
    btn.addEventListener('click', e => {
      if (o.trigger) { open(pop, true); return; }
      e.stopPropagation();
      if (!panel.hidden && pinnedKey === key) close(pop, false); else open(pop, true);
    });
    btn.addEventListener('focus', () => { if (!refocusing) open(pop, false); });
    // a click anywhere inside an open popover keeps it open (pins it) so the reader can scroll, unfold and move away
    panel.addEventListener('click', () => { if (!panel.hidden && pinnedKey !== key) { pinnedKey = key; panel.dataset.pinned = 'true'; } });
    [wrap, ...(o.trigger ? [btn] : [])].forEach(el => {
      el.addEventListener('focusout', e => { if (!inside(e.relatedTarget) && pinnedKey !== key) close(pop, false); });
      el.addEventListener('mouseenter', () => open(pop, false));
      el.addEventListener('mouseleave', () => later(pop));      // the grace period lets the pointer cross from the trigger into the panel
      el.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { e.stopPropagation(); close(pop, true); } });
    });
    if (pinnedKey === key) open(pop, true);   // a re-render (new turn, hotline click) keeps a pinned explanation open
    adoptSheet(pop);                          // and an open Details panel shows the new turn's data
    wrap.pop = pop;
    return wrap;
  }

  // ---------- cause percentage ----------
  function kLine(d) {
    const k = d.kNow();
    return d.h('div', {class: 'v4-xp-k'}, 'K1 = ' + fmt(k.k1) + ' and K2 = ' + fmt(k.k2) + ' choose the next question, they do not change this percentage. ',
      d.h('button', {type: 'button', class: 'v4-link', onclick: () => { close(openPop, false); closeSheet(false); d.focus('questions', 'order'); }}, 'See how questions are chosen'));
  }
  // 'Score → share of the open causes → adjustment = result' in one line; null without the server breakdown
  function chainText(c, d) {
    const e = c.explain;
    if (!e || typeof e !== 'object' || num(get(e, 'score')) === null) return null;
    const open = num(get(e, 'open')), adjust = num(get(e, 'adjust')), renorm = num(get(e, 'renorm')) || NO_FACTOR;
    const adjusted = adjust !== null && adjust !== NO_FACTOR, reshared = Math.abs(renorm - NO_FACTOR) > 1e-9;
    return 'Score ' + fmt(get(e, 'score')) + ' → share of ' + (open !== null ? 'all ' + open + ' open causes' : 'the open causes') + ' = ' + pct1(get(e, 'shareBefore')) +
      (adjusted ? ' → ×' + +adjust.toPrecision(3) : '') + (reshared ? ' → shared out again' : '') + ' = ' + d.pct(c.post) + '%';
  }
  // short form: the cause and how its percentage was reached, in one line
  const causeShort = (c, d) => ({title: (d.cleanLabel(c.label) || 'This cause') + ': ' + d.pct(c.post) + '%', gist: chainText(c, d) || NO_DETAIL});
  function causeBody(c, d) {
    const e = c.explain, name = d.cleanLabel(c.label) || 'This cause';
    const head = d.h('div', {class: 'v4-label'}, 'How ' + d.pct(c.post) + '% was reached');
    if (!e || typeof e !== 'object' || num(get(e, 'score')) === null) return d.h('div', null, head, d.muted(NO_DETAIL), kLine(d));
    const boost = num(get(e, 'boost')) || NO_FACTOR, soft = num(get(e, 'soft')) || NO_FACTOR;
    const adjust = num(get(e, 'adjust')), renorm = num(get(e, 'renorm')) || NO_FACTOR;
    const nObs = num(get(e, 'nObs')), open = num(get(e, 'open')), cases = num(get(e, 'cases')), wrong = num(get(e, 'wrong'));
    const rawReasons = get(e, 'reasons'), reasons = (Array.isArray(rawReasons) ? rawReasons : []).map(r => REASON_TEXT[r] || d.cleanLabel(r)).filter(Boolean);
    const boosted = boost > NO_FACTOR, softened = soft < NO_FACTOR, adjusted = adjust !== null && adjust !== NO_FACTOR;
    const reshared = Math.abs(renorm - NO_FACTOR) > 1e-9, moved = num(c.last_move);
    // prior_log already holds log(boost) (score_explain): split it so the season boost gets its own row
    const prior = num(get(e, 'prior')) === null ? null : num(get(e, 'prior')) - (boosted ? Math.log(boost) : 0);
    const priorWhy = 'Starts from how often this cause was confirmed' + (cases !== null ? ' (' + fmt(cases) + ' recent confirmed conversation-weight' + (cases === 1 ? '' : 's') + ')' : '') +
      ' compared with all causes. ' + (wrong ? 'Lowered by ' + fmt(wrong) + ' wrong diagnosis weight. ' : '') + 'More confirmed conversations give a higher start.';
    const evWhy = nObs !== null
      ? 'How well the ' + d.plural(nObs, 'answer') + ' so far fit this cause' + (nObs > 1 ? ', divided by √' + nObs + ' so related answers are not counted ' + nObs + ' times' : '') + '.'
      : 'How well the answers so far fit this cause.';
    const rows = [
      ['Prior from past conversations', signed(prior), priorWhy],
      ['Evidence from answers', signed(get(e, 'evidence')), evWhy + ' Closer to 0 fits better.'],
      boosted ? ['In season boost', signed(Math.log(boost)), 'Marked in season by an SME: starting weight ×' + boost + '.'] : null,   // only when it changed the score
      softened ? ['Guide rule-out', signed(Math.log(soft)), SOFT_TEXT + ' Weight ×' + soft + '.'] : null,
      ['Score', fmt(get(e, 'score')), 'The sum of the rows above. Only the gap to the other open causes matters.'],
      ['Share of open causes', pct1(get(e, 'shareBefore')), 'Its score\'s share of ' + (open !== null ? 'all ' + d.plural(open, 'open cause') : 'the open causes') + '.'],
      ['Rule-out adjustment', adjusted ? '×' + +adjust.toPrecision(3) : 'none',
        (reasons.length ? reasons.join(' ') : 'No check in this chat weakened it.') + (reshared ? ' The open causes were then shared out again to 100%.' : '')],
      moved ? ['Last answer', points(moved), 'The last answer ' + (moved > 0 ? 'raised' : 'lowered') + ' it by ' + plainPoints(moved) + '.'] : null,
      ['Result', d.pct(c.post) + '%', 'What the list shows.'],
    ].filter(Boolean);
    const table = d.h('table', {class: 'v4-xp-table'},
      d.h('thead', null, d.h('tr', null, ['Part', 'Value', 'What it means'].map(t => d.h('th', {scope: 'col'}, t)))),
      d.h('tbody', null, rows.map(([part, value, why], i) => d.h('tr', {class: i === rows.length - 1 ? 'v4-xp-result' : ''},
        d.h('th', {scope: 'row'}, part), d.h('td', {class: 'v4-xp-val'}, value), d.h('td', null, why)))));
    const chain = chainText(c, d);
    const capped = num(c.post) !== null && c.post > d.cap ? d.muted('Shown as at most ' + Math.round(d.cap * 100) + '%: the panel never claims full certainty.') : null;
    return d.h('div', null, head, d.h('div', {class: 'v4-xp-name'}, name), d.h('div', {class: 'v4-scroll'}, table),
      d.h('div', {class: 'v4-formula v4-xp-chain'}, chain), capped,
      d.h('p', {class: 'v4-muted v4-xp-foot', title: SOFTMAX_NOTE}, 'Each cause gets a score; the percentages are each score\'s share of all open causes, so they add up to 100%.'),
      kLine(d));
  }
  // the percentage becomes the trigger; the bar opens the same popover on hover or tap
  function pctTrigger(c, d) {
    const p = d.pct(c.post), name = d.cleanLabel(c.label) || 'this cause';
    return popover(d, 'pct-' + c.pid, 'How the percentage for ' + name + ' was reached',
      {class: 'v4-pct v4-xp-btn', 'aria-label': p + '%: how it was reached'}, p + '%', () => causeBody(c, d), {short: () => causeShort(c, d)});
  }
  function barHover(bar, trigger) {
    const pop = trigger && trigger.pop;
    if (!pop) return bar;
    pop.extra.push(bar);
    bar.classList.add('v4-xp-bar');
    bar.addEventListener('mouseenter', () => open(pop, false));
    bar.addEventListener('mouseleave', () => later(pop));
    bar.addEventListener('click', e => { e.stopPropagation(); open(pop, true); });
    return bar;
  }

  // ---------- track record: the original line keeps its look; a 'how?' button opens why THIS cause shows its value ----------
  const TRACK_FORMULA = 'Track record = (confirmed + 1) / (confirmed + wrong + 2)';
  const TRACK_INFO = 'The track record is shown for information. The percentage uses confirmed and wrong conversations through its prior.';
  const TRACK_MOVES = ['Each confirmed conversation raises it.', 'Each wrong diagnosis lowers it.', 'Time lowers it slowly: older conversations count less.'];
  const ZERO_W = 0.005;   // decayed weights below this read as 'none' in the plain sentence
  // The popover explains exactly the number on the row, which trackLine() takes from /api/causes (causeInfo) or the card, never
  // explain.trust (with Learning off the card is scored from the guide alone). /api/causes sends the STORED weights (cases_w, wrong_w)
  // but not their decayed values; the decay factor f is the same for both, so the shown value fixes them:
  //   t = (cw·f + b + 1) / (cw·f + ww·f + b + 2)  =>  f = (b + 1 − t(b + 2)) / (t(cw + ww) − cw);  with ww = 0: cw·f = (2t − 1)/(1 − t) − b
  function trackFrom(t, cw, ww, book) {
    const b = book ? BOOK_TRUST_WEIGHT : 0;
    let cases = null, wrong = null;
    if (ww === 0) { cases = (2 * t - 1) / (1 - t) - b; wrong = 0; }
    else if (cw !== null && ww !== null) {
      const den = t * (cw + ww) - cw, f = (b + 1 - t * (b + 2)) / den;
      if (Number.isFinite(f) && f > 0) { cases = cw * f; wrong = ww * f; }
    }
    if (cases === null || cases < -ZERO_W) return null;
    cases = Math.max(cases, 0);
    const r = cases + b, value = (r + 1) / (r + wrong + 2);
    return Math.abs(value - t) < TRUST_MATCH ? {cases, wrong, r, book} : null;   // only an unambiguous, self-consistent answer is shown
  }
  // /api/causes cases_w_now, wrong_w_now, trust_book_bonus: the exact numbers, used when they reproduce the shown value
  function trackExact(t, info) {
    const cases = num(info.cases_w_now), wrong = num(info.wrong_w_now), bonus = num(info.trust_book_bonus);
    if (cases === null || wrong === null || bonus === null) return null;
    const r = cases + bonus;
    return Math.abs((r + 1) / (r + wrong + 2) - t) < TRUST_MATCH ? {cases, wrong, r, book: bonus > 0} : null;
  }
  function trackNumbers(c, d) {
    const info = d.causeInfo(c.pid) || {}, e = c.explain || {};
    const shown = num(info.trust !== undefined ? info.trust : c.trust);
    const src = info.source || c.source || [];
    const base = {shown, book: src.includes('book'), count: num(info.cases !== undefined ? info.cases : c.cases), wrongCount: num(info.wrong !== undefined ? info.wrong : c.wrong)};
    if (shown === null) return base;
    const exact = trackExact(shown, info), book = exact ? exact.book : base.book;
    const start = (book ? BOOK_TRUST_WEIGHT + 1 : 1) / (book ? BOOK_TRUST_WEIGHT + 2 : 2);
    if (exact) return Object.assign(base, {start}, exact);
    // fallbacks: the card's own decayed weights, only when they reproduce the shown value (Learning on); else derived from the stored weights
    const fromCard = num(get(e, 'cases')) !== null && num(get(e, 'wrong')) !== null ? trackFrom(shown, num(get(e, 'cases')), num(get(e, 'wrong')), book) : null;
    const cardOk = fromCard && Math.abs(fromCard.cases - num(get(e, 'cases'))) < ZERO_W;
    const fit = cardOk ? fromCard : trackFrom(shown, num(info.cases_w !== undefined ? info.cases_w : c.cases_w), num(info.wrong_w !== undefined ? info.wrong_w : c.wrong_w), book);
    return Object.assign(base, {start}, fit || {});
  }
  function trackReason(n) {
    const from = n.book ? 'like every cause from the guide' : 'like every cause not in the guide';
    if (n.cases < ZERO_W && n.wrong < ZERO_W) return 'No conversation has been taught for this cause yet, so it starts at ' + n.start.toFixed(NUM_DIGITS) + ', ' + from + '.';
    const side = n.shown > n.start + ZERO_W ? 'above' : n.shown < n.start - ZERO_W ? 'below' : 'at';
    const counted = (k, w) => (k !== null ? k + ' conversation' + (k === 1 ? '' : 's') + ' (' + fmt(w) + ' once older conversations count less)' : fmt(w) + ' recent conversation-weight' + (w === 1 ? '' : 's'));
    return 'Confirmed in ' + counted(n.count, n.cases) + ' and wrong in ' + (n.wrong < ZERO_W ? 'none' : counted(n.wrongCount, n.wrong)) +
      ', so it is ' + side + ' the starting ' + n.start.toFixed(NUM_DIGITS) + '.';
  }
  function trackTitle(n) {
    if (n.cases === undefined) return TRACK_FORMULA + (n.shown !== null ? '\nShown: ' + n.shown.toFixed(NUM_DIGITS) : '');
    return TRACK_FORMULA + '\nThis cause: (' + fmt(n.r) + ' + 1) / (' + fmt(n.r) + ' + ' + fmt(n.wrong) + ' + 2) = ' + n.shown.toFixed(NUM_DIGITS);
  }
  function trackBody(c, d) {
    const n = trackNumbers(c, d), delta = d.trustDelta ? d.trustDelta(c.pid) : null;
    const head = d.h('div', {class: 'v4-label'}, 'Why the track record is ' + (n.shown !== null ? n.shown.toFixed(NUM_DIGITS) : 'not shown'));
    const off = d.learningOn && !d.learningOn() ? d.muted('Learning is off for this chat, but this track record is from the conversations already taught.') : null;
    const changed = delta ? d.h('p', {class: delta > 0 ? 'v4-up' : 'v4-down'}, 'Teaching in this chat ' + (delta > 0 ? 'raised' : 'lowered') + ' it by ' + Math.abs(delta).toFixed(NUM_DIGITS) + '.') : null;
    const moves = d.h('div', null, d.h('div', {class: 'v4-label'}, 'What moves it'), d.h('ul', {class: 'v4-terms'}, TRACK_MOVES.map(t => d.h('li', null, t))));
    if (n.cases === undefined) {
      return d.h('div', null, head, off, d.h('div', {class: 'v4-formula'}, '(confirmed + 1) ÷ (confirmed + wrong + 2)'),
        d.muted('The confirmed and wrong counts of past conversations move it. This cause\'s recent confirmed and wrong weights are not available here, so the numbers cannot be filled in.'),
        changed, moves, d.muted(TRACK_INFO));
    }
    return d.h('div', null, head, off, d.h('p', {class: 'v4-xp-name'}, trackReason(n)),
      d.h('div', {class: 'v4-formula'}, '(confirmed + 1) ÷ (confirmed + wrong + 2)'),
      d.h('div', {class: 'v4-formula'}, '(' + fmt(n.r) + ' + 1) ÷ (' + fmt(n.r) + ' + ' + fmt(n.wrong) + ' + 2) = ' + n.shown.toFixed(NUM_DIGITS)),
      d.h('ul', {class: 'v4-terms'},
        d.h('li', null, bold(d, 'Confirmed ' + fmt(n.r)), ': ' + fmt(n.cases) + ' confirmed conversation-weight' + (n.cases === 1 ? '' : 's') + ', older conversations count less' +
          (n.book ? ', plus ' + BOOK_TRUST_WEIGHT + ' because the guide lists this cause' : '') + '.'),
        d.h('li', null, bold(d, 'Wrong ' + fmt(n.wrong)), ': times it was diagnosed and turned out wrong, older ones count less.'),
        d.h('li', null, 'The +1 and +2 keep a new cause near one half, never 0 or 1.')),
      changed, moves, d.muted(TRACK_INFO));
  }
  // the line keeps its original text and 'after teaching' change and its native title; a small 'how?' button is appended
  function trackTrigger(line, c, d) {
    if (!line) return line;
    line.title = trackTitle(trackNumbers(c, d));
    const btn = popover(d, 'track-' + c.pid, 'Why the track record has this value',
      {class: 'v4-link v4-xp-track', 'aria-label': 'Why the track record has this value'}, 'how?', () => trackBody(c, d), {short: () => trackShort(c, d)});
    line.append(' ', btn);
    return line;
  }
  // short form: the value and the plain reason for it (or the formula when the weights are not available)
  function trackShort(c, d) {
    const n = trackNumbers(c, d);
    return {title: 'Track record ' + (n.shown !== null ? n.shown.toFixed(NUM_DIGITS) : 'not shown'),
      gist: n.cases === undefined || n.shown === null ? TRACK_FORMULA : trackReason(n)};
  }

  // ---------- map node (any node but a cause, whose write-up is rhs4_causedetail.js): its tooltip lines ----------
  // lines() = DiagMapLayout tipLines: [label, 'Type: state', ...details]. The short form is the label and the next lines cut to one;
  // Details shows every line.
  function nodeTrigger(node, n, lines, d) {
    const name = d.cleanLabel(n.label) || n.id;
    const full = () => {
      const all = lines() || [];
      return d.h('div', {class: 'v4-xp-node'}, d.h('div', {class: 'v4-xp-name'}, all[0] || name),
        all.slice(1).map(t => d.h('p', {class: 'v4-xp-line'}, t)));
    };
    const short = () => { const all = lines() || []; return {title: all[0] || name, gist: all.slice(1).join(' · ')}; };
    const wrap = popover(d, 'map-node-' + n.id, 'About ' + name, null, null, full, {fixed: true, refresh: true, trigger: node, short});
    wrap.classList.add('v4-cd-holder');
    return wrap;
  }

  // ---------- In season help ----------
  function boostHelp(sel, d) {
    sel.title = 'Starting weight multiplier for causes marked In season, for ' + HOTLINE_DAYS + ' days';
    const id = 'v4-boost-help';
    const text = d.h('p', {class: 'v4-muted v4-xp-help', id: id, hidden: true}, BOOST_TEXT);
    const btn = d.h('button', {type: 'button', class: 'v4-xp-info', 'aria-expanded': 'false', 'aria-controls': id, 'aria-label': 'What In season strength does', title: BOOST_TEXT}, 'i');
    btn.addEventListener('click', () => { text.hidden = !text.hidden; btn.setAttribute('aria-expanded', String(!text.hidden)); });
    sel.setAttribute('aria-describedby', id);
    return {btn, text};
  }
  // the flame's tooltip names the active factor and the expiry, so the SME sees what is switched on without opening anything
  function hotTitle(on, c, d) {
    if (!on) return 'Mark in season';
    const info = d.causeInfo(c.pid) || {}, boost = info.hotline_boost || c.hotline_boost, until = info.hotline_until || c.hotline_until;
    return 'In season' + (boost ? ' ×' + Number(boost) : '') + (until ? ' until ' + until : '') + ': click to remove';
  }

  window.Rhs4Explain = {pctTrigger, barHover, trackTrigger, boostHelp, hotTitle, reset, popover, refresh, trackBody, nodeTrigger,
    detailsFor, closeDetails: () => closeSheet(false), isOpen, shorten};
})();
